import { Controller } from "stimulus"

export default class extends Controller {
    static targets = [
        'issuedReceiptIndicator',
        'removeReceiptLink',
        'issueReceiptLink',
        'procedureDebt',
        'procedureReceipt',
        'boletosGenerate',
        'receiptsGenerate',
        'boletosSum',
        'receiptsSum',
        'boletoTopBar',
        'boletoSelected',
        'receiptSelected',
        'summaryOfPayments',
        'batchPaymentsGenerate',
        'batchPaymentsDelete',
        'batchPaymentsGenerateButton',
        'boletosGenerateButton',
        'batchPaymentsDeleteButton',
        'batchPaymentGenerateButtonDisabled',
        'boletosGenerateButtonDisabled',
        'batchPaymentsDeleteButtonDisabled',
        'receiptGenerateButtonDisabled',
        'receiptGenerateButton',
        "batchPaymentInstallmentButtonDisabled",
        "batchPaymentInstallmentButton",
    ]

    connect(){
        this.hasBoletoFeature = JSON.parse(this.element.dataset.hasBoleto)
        this.installmentsDebtsId = []
        this.selectedDebtsIds = [];
        this.selectedPaidDebtsIds = [];

        this.updateDebtNameWidth();
        this.handleResize = _.debounce(() => {
            this.updateDebtNameWidth()
        }, 100)

        window.addEventListener('resize', this.handleResize)
    }

    tearDown() {
        window.removeEventListener('resize', this.handleResize)
    }

    issueReceipt(e) {
        if (this.data.get('message-confirm') == 'true') {
            e.preventDefault()
            self = this
            swal({
                title: this.data.get('title'),
                html: this.data.get('message'),
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancelar'
            }).then((result) => {
                if (result.value) {
                    this.data.delete('message-confirm')
                    this.issueReceiptLinkTarget.click()
                }
            })
        } else if (this.data.get('message')) {
            e.preventDefault()

            swal({
                title: this.data.get('title'),
                html: this.data.get('message'),
                type: 'warning',
                confirmButtonText: 'OK'
            })
        } else if (this.data.get('issued-as-establishment') == 'true') {
            e.preventDefault()
            self = this
            swal({
                title: 'O recibo será emitido em nome da clínica pois este recebimento possui mais de um dentista',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancelar'
            }).then((result) => {
                if (result.value) {
                    this.data.delete('issued-as-establishment')
                    this.issueReceiptLinkTarget.click()
                }
            })
        } else {
            this.addIssuedReceiptIndicator()
            this.replaceIssueReceiptLink()
        }
    }

    replaceIssueReceiptLink() {
        $(this.removeReceiptLinkTarget).removeClass('hidden')
        $(this.issueReceiptLinkTarget).addClass('hidden')
    }

    addIssuedReceiptIndicator() {
        $(this.issuedReceiptIndicatorTarget).removeClass('hidden')
    }

    boleto() {
        var ids
        var value
        ids = '?'
        var totalSelected = 0
        const boletosIds = [];
        const idsList = []

        this.procedureDebtTargets.forEach((input) => {
            value = input.value.split("|")
            value = value[0]
            if (input.checked) {
                totalSelected++
                $(this.summaryOfPaymentsTarget).removeClass('tw-pt-12')
                $(this.summaryOfPaymentsTarget).addClass('tw-pt-5')
                ids += 'ids[]=' + value + '&'
                idsList.push(value)
            }
            if (totalSelected > 0) {
                $(this.summaryOfPaymentsTarget).removeClass('tw-pt-12')
                $(this.summaryOfPaymentsTarget).addClass('tw-pt-5')
            } else {
                $(this.summaryOfPaymentsTarget).addClass('tw-pt-12')
                $(this.summaryOfPaymentsTarget).removeClass('tw-pt-5')
            }
            if (input.checked && input.dataset.boletoId) {
                boletosIds.push(`load_boleto[]=${input.dataset.boletoId}`)
            }
        })

        this.boletosGenerateButtonTarget.innerText = 'Gerar boleto'
        if (boletosIds.length === 1) {
            this.boletosGenerateButtonTarget.innerText = 'Imprimir boleto'
        }
        if (boletosIds.length > 1) {
            this.boletosGenerateButtonTarget.innerText = 'Imprimir boletos'
        }

        if (ids != '?') {
            if (this.hasBatchPaymentsGenerateTarget) {
                this.batchPaymentsGenerateTarget.href = this.buildPayUrl(ids, idsList)
            }
            if (this.hasBatchPaymentsDeleteTarget) {
                this.batchPaymentsDeleteTarget.href = "/batch_payment/modal_batch_payment_collection" + ids
            }

            if (this.hasBoletosGenerateTarget) {
                if (this.hasBoletoFeature){
                    this.boletosGenerateTarget.href = "/boleto/modal_boleto_collection" + ids
                } else {
                    this.boletosGenerateTarget.href = this.element.dataset.boletoUpgradeLink
                }
            }
        }

        if (this.hasBoletoFeature && boletosIds.length > 0 && this.hasBoletosGenerateTarget) {
            this.boletosGenerateTarget.href = "/boleto/modal_boleto_collection?" + boletosIds.join("&")
        }
    }

    receipt() {
        var ids
        var value
        ids = "?"
        var totalSelected = 0
        var patient_id_value = this.procedureReceiptTarget.value.split("|")[2]
        var patient_id = "patient_id=" + patient_id_value
        this.procedureReceiptTargets.forEach((input) => {
            value = input.value.split("|")
            value = value[0]
            if (input.checked) {
                totalSelected++
                $(this.summaryOfPaymentsTarget).removeClass("tw-pt-12")
                $(this.summaryOfPaymentsTarget).addClass("tw-pt-5")
                ids += "ids[]=" + value + "&"
            }
            if (totalSelected > 0) {
                $(this.summaryOfPaymentsTarget).removeClass("tw-pt-12")
                $(this.summaryOfPaymentsTarget).addClass("tw-pt-5")
            } else {
                $(this.summaryOfPaymentsTarget).addClass("tw-pt-12")
                $(this.summaryOfPaymentsTarget).removeClass("tw-pt-5")
            }
        })
        if (ids != "?") {
            if (this.receiptsGenerateTarget) {
                this.receiptsGenerateTarget.target = "_blank"
                this.receiptsGenerateTarget.href = "/batch_receipt" + ids + patient_id
            }
        }
        this.receiptGenerateButtonTarget.textContent = ("Emitir Recibo (" + String(totalSelected) + ")")
    }

    sumOfAmounts() {
        var amount
        var textSelected
        this.boletosSumTarget.textContent = 0
        this.boletoSelectedTarget.textContent = 0
        this.receiptsSumTarget.textContent = 0
        this.receiptSelectedTarget.textContent = 0
        this.procedureDebtTargets.forEach((input) => {
            amount = input.value.split("|")
            amount = amount[1]
            if (input.checked) {
                this.boletosSumTarget.textContent = (parseFloat(amount) + parseFloat(this.boletosSumTarget.textContent))
                textSelected = parseInt(this.boletoSelectedTarget.textContent) + parseInt(this.receiptSelectedTarget.textContent) > 0 ? " débitos selecionados" : " débito selecionado"
                this.boletoSelectedTarget.textContent = (parseInt(this.boletoSelectedTarget.textContent) + 1) + textSelected;
            }
        })
        this.procedureReceiptTargets.forEach((input) => {
            amount = input.value.split("|")
            amount = amount[1]
            if (input.checked) {
                this.receiptsSumTarget.textContent = (parseFloat(amount) + parseFloat(this.receiptsSumTarget.textContent))
                textSelected = parseInt(this.boletoSelectedTarget.textContent) + parseInt(this.receiptSelectedTarget.textContent) > 0 ? " débitos selecionados" : " débito selecionado"
                this.boletoSelectedTarget.textContent = ((parseInt(this.boletoSelectedTarget.textContent)) + (parseInt(this.receiptSelectedTarget.textContent)) + 1) + textSelected;
            }
        })
        if (parseFloat(this.boletosSumTarget.textContent) == 0 && parseFloat(this.receiptsSumTarget.textContent) == 0) {
            $(this.boletoTopBarTarget).hide()
        } else {
            $(this.boletoTopBarTarget).show()
        }

        if(parseFloat(this.boletosSumTarget.textContent) > 0) {
            this.receiptsGenerateTarget.disabled = true
            $(this.receiptGenerateButtonDisabledTarget).removeClass("hidden")
        } else {
            this.receiptsGenerateTarget.disabled = false
            $(this.receiptGenerateButtonDisabledTarget).addClass("hidden")
        }

        if (parseFloat(this.receiptsSumTarget.textContent) > 0) {
            this.receiptsGenerateTarget.style = "display: initial"

            this.batchPaymentsGenerateButtonTarget.disabled = true
            $(this.batchPaymentsGenerateButtonTarget).addClass("hidden")
            $(this.batchPaymentGenerateButtonDisabledTarget).removeClass("hidden")

            this.boletosGenerateButtonTarget.disabled = true
            $(this.boletosGenerateButtonTarget).addClass("hidden")
            $(this.boletosGenerateButtonDisabledTarget).removeClass("hidden")

            this.batchPaymentsDeleteButtonTarget.disabled = true
            $(this.batchPaymentsDeleteButtonTarget).addClass("hidden")
            $(this.batchPaymentsDeleteButtonDisabledTarget).removeClass("hidden")

            $(this.receiptGenerateButtonDisabledTarget).addClass("hidden")
        } else {
            this.receiptsGenerateTarget.style = "display: none"

            this.batchPaymentsGenerateButtonTarget.disabled = false
            $(this.batchPaymentsGenerateButtonTarget).removeClass("hidden")
            $(this.batchPaymentGenerateButtonDisabledTarget).addClass("hidden")

            if (this.hasBoletosGenerateButtonTarget) {
                this.boletosGenerateButtonTarget.disabled = false
            }

            $(this.boletosGenerateButtonTarget).removeClass("hidden")
            $(this.boletosGenerateButtonDisabledTarget).addClass("hidden")

            if (this.hasBatchPaymentsDeleteButtonTarget) {
                this.batchPaymentsDeleteButtonTarget.disabled = false
                $(this.batchPaymentsDeleteButtonTarget).removeClass("hidden")
            }

            $(this.batchPaymentsDeleteButtonDisabledTarget).addClass("hidden")
        }

        this.boletosSumTarget.textContent = "Total " + (parseFloat(this.boletosSumTarget.textContent) + parseFloat(this.receiptsSumTarget.textContent)).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
    }

    handleInstallment(event) {
        const {paidAt, debtId} = event.currentTarget.dataset
        this.selectedDebtsIds = this.toggleItemFromArray(
            this.selectedDebtsIds,
            debtId,
            event.currentTarget.checked ? "insert" : "remove"
        );
        if (paidAt) {
            this.selectedPaidDebtsIds = this.toggleItemFromArray(
                this.selectedPaidDebtsIds,
                debtId,
                event.currentTarget.checked ? "insert" : "remove"
            );
        }

        this.batchPaymentInstallmentButtonDisabledTarget
            .classList
            .toggle("tw-hidden", this.selectedPaidDebtsIds.length === 0);
        this.batchPaymentInstallmentButtonTarget
            .classList
            .toggle("tw-hidden", this.selectedPaidDebtsIds.length > 0);
        if (this.selectedPaidDebtsIds.length > 0) return
        this.batchPaymentInstallmentButtonTarget.href = `${this.batchPaymentInstallmentButtonTarget.dataset.href}?${this.buildQueryStringFromArray("debt_ids", this.selectedDebtsIds)}`
    }

    toggleItemFromArray(list, item, action) {
        if (action === "insert") return [].concat(list, item);
        if (action === "remove") return list.filter(id => id !== item);
        throw new Error("Invalid action")
    }

    buildQueryStringFromArray(name, list) {
        return list.map(item => `${name}[]=${item}`).join("&")
    }

    buildPayUrl(ids, idsList){
        return idsList.length === 1
            ? `/patients/${this.data.get("patient-id")}/debts/${idsList[0]}/pay/new`
            : `/batch_payment/modal_batch_payment_collection${ids}`
    }

    updateDebtNameWidth() {
        let width = this.element.clientWidth * 0.5
        if (window.matchMedia("screen and (max-width:769px)").matches) {
            width = this.element.clientWidth - 73 // Remove gaps
        }
        this.element.style.setProperty('--debt-name-width', `${width}px`);
    }
}
